import { GetterTree } from "vuex";
import { RootState } from "../types";
import { IntAddCanidates } from "./types";
export const getters: GetterTree<IntAddCanidates, RootState> = {};
